// Busca os dados editáveis do site (planos e configurações de O.S.) no backend PHP.
// O arquivo dados-site.json é atualizado pelo painel-planos.php.
const DEFAULT_URL = 'https://faynetrj.com.br/backend-php-www/dados-site.json';

const resolveDadosSiteUrl = () => {
  if (typeof window === 'undefined') return DEFAULT_URL;
  if (window.MSA_DADOS_SITE_URL) return window.MSA_DADOS_SITE_URL;
  if (window.MSA_SEGUNDA_VIA_URL) {
    return window.MSA_SEGUNDA_VIA_URL.replace(/ixc\.php$/, 'dados-site.json');
  }
  return DEFAULT_URL;
};

let cachedPromise = null;

// Retorna null em caso de falha, para que os componentes usem os valores padrão embutidos.
export function fetchDadosSite() {
  if (!cachedPromise) {
    cachedPromise = fetch(resolveDadosSiteUrl())
      .then((res) => (res.ok ? res.json() : null))
      .catch(() => null);
  }
  return cachedPromise;
}
